var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",style:({ width: _vm.size, height: _vm.size })},[_c('use',{attrs:{"xlink:href":("#sprite_icon-" + _vm.iconName)}})])}
var staticRenderFns = []

export { render, staticRenderFns }